export default {"src":"/_next/static/media/TIFF.48c05e1c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};